import {
  updateTimebasedCategory,
  updateTimeBasedCategoryDetailsWithMenuReducer,
  onClickTimeSpecificCloseBtnHandler,
  onClickTimeSpecificBtnHandler,
} from '../Utils/DynamicMenuAlertUtils';
import { UserOrderContext } from 'context/context';
import { useCallback, useContext, useEffect } from 'react';
import { getValueOrDefaultObject, replaceCategoryName } from '../../../../common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getStoreDetails } from '../../../../organisms/HeaderComponent/AU/HeaderUtilities/HeaderUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';

export const DynamicMenuAlertComponent = () => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { menuReducer, PlpDisclaimerReducerContent } = useSelector(data => data);
  const storeData = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const cartReducer = useSelector(data => data.cartReducer);
  const { timeBasedCetegory, timeBasedAlertModalData } = userOrderState;
  const dispatch = useDispatch();
  const history = useHistory();
  const { CartError } = IMAGE_PATH;

  const getUpdateStoreDetails = () => {
    return storeData?.storesWithStatus && getStoreDetails(storeData?.storesWithStatus[0]);
  };
  const getStoreDetail = getUpdateStoreDetails();

  const getUpdateSupportContentAlertData = useCallback(() => {
    if (!timeBasedCetegory?.supportContentAlertData) {
      const supportContentAlertData = PlpDisclaimerReducerContent?.response?.plpDisclaimerResponseData?.includes?.Entry;
      if (supportContentAlertData?.length) {
        updateTimebasedCategory({ ...timeBasedCetegory, supportContentAlertData }, userOrderStateDispatch);
      }
    }
  }, [PlpDisclaimerReducerContent, timeBasedCetegory, userOrderStateDispatch]);

  useEffect(() => {
    getUpdateSupportContentAlertData();
  }, [getUpdateSupportContentAlertData]);

  useEffect(() => {
    const paramsData = {
      menuReducer: menuReducer,
      userParams: userParams,
      updateTimebasedCategory: updateTimebasedCategory,
      userOrderStateDispatch: userOrderStateDispatch,
      dispatch: dispatch,
      getStoreDetail: getStoreDetail,
      cartReducer: cartReducer,
      timeBasedCetegory: timeBasedCetegory,
    };
    updateTimeBasedCategoryDetailsWithMenuReducer(paramsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuReducer]);

  return (
    <>
      {/* Show timespecific category alert */}
      {timeBasedAlertModalData?.flag && (
        <CartAlertFormInsideModel
          data-testid='timeBasedAlert-modal'
          handleClose={
            timeBasedAlertModalData?.showCrossIcon
              ? () => onClickTimeSpecificCloseBtnHandler(userOrderStateDispatch, timeBasedAlertModalData)
              : null
          }
          classNames={`clear-cart-modal catering-menu-nav-alert timebased-alert ${
            timeBasedAlertModalData?.title !== START_ORDER_CONSTANTS?.CART_REVIEW_ORDER_MODAL
              ? 'timebased-alert-notification'
              : 'timebased-alert-popup'
          }`}
          CartAlertForm={
            <CartAlertForm
              title={replaceCategoryName(timeBasedAlertModalData?.headline, timeBasedAlertModalData?.cName)}
              contentMsg={replaceCategoryName(timeBasedAlertModalData?.subHeadline, timeBasedAlertModalData?.cName)}
              contentImg={timeBasedAlertModalData?.contentImg}
              imageSrc={!timeBasedAlertModalData?.contentImg ? CartError : null}
              altText={''}
              confirmButtonText={translateWithI18Next(timeBasedAlertModalData?.buttonText)}
              confirmHandler={() =>
                onClickTimeSpecificBtnHandler({
                  timeBasedAlertModalData,
                  userOrderStateDispatch,
                  timeBasedCetegory,
                  history,
                })
              }
            />
          }
        />
      )}
    </>
  );
};

export default DynamicMenuAlertComponent;
